module.exports = __webpack_public_path__ + "static/index/img/baikal-100.788548eb.jpg";